export default __webpack_public_path__ + "static/media/holiday2.0fa596ab.jpeg";